import React, { useState, useEffect } from "react";
import NavBar from "../../../components/navbar/NavBar";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Swal from "sweetalert2";
import Tooltip from "@mui/material/Tooltip";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { useSelector } from "react-redux";
import useLocalWallet from "../../../utils/hooks";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import messages from "../../../constants/messages";
import { Modal, Button } from "react-bootstrap";

const AdminWalletChangeRequests = () => {
  const { sortField, sortOrder, sortHistory, onSort, copyToClipboard } =
    useLocalWallet();
  const [isOpen, setIsopen] = useState(false);
  const [reason, setReason] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pendingRequests, setPendingRequests] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    walletAddress: "",
  });
  const user = useSelector((state) => state.userStore.user);
  const token = user.auth;

  useEffect(() => {
    fetchAllPendingRequests();
  }, [navigate]);

  const fetchAllPendingRequests = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_URL}/admin/allWalletAddressUpdateRequest`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setPendingRequests(response.data?.walletAddress);
    } catch (error) {
      Swal.fire({
        title: messages.titles.error,
        text: messages.errors.fetchUsersFailed,
        icon: "error",
        confirmButtonText: messages.buttons.ok,
      });
    }
  };

  const capitalizeFirstLetter = (string) => {
    if (typeof string !== "string" || string.length === 0) {
      return "";
    }
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  const onFilterChange = (e, field) => {
    const value = e.target.value;
    setFilters((prevFilters) => ({ ...prevFilters, [field]: value }));
  };

  const filterUsers = () => {
    return pendingRequests.filter((request) => {
      const user = request.userId;

      const firstNameMatch = user?.firstName
        ? capitalizeFirstLetter(user.firstName)
            .toLowerCase()
            .includes(filters.firstName.toLowerCase())
        : true;

      const lastNameMatch = user?.lastName
        ? capitalizeFirstLetter(user.lastName)
            .toLowerCase()
            .includes(filters.lastName.toLowerCase())
        : true;

      const emailMatch = user?.email
        ? user.email.toLowerCase().includes(filters.email.toLowerCase())
        : true;

      const phoneMatch = user?.phone
        ? String(user.phone).toLowerCase().includes(filters.phone.toLowerCase())
        : true;

      const walletAddressMatch = user?.walletAddress
        ? user.walletAddress
            .toLowerCase()
            .includes(filters.walletAddress.toLowerCase())
        : false;

      return (
        firstNameMatch &&
        lastNameMatch &&
        emailMatch &&
        phoneMatch &&
        (filters.walletAddress ? walletAddressMatch : true)
      );
    });
  };

  const filteredUsers = filterUsers();
  const sortedUsers = sortHistory(filteredUsers);

  const renderHeader = () => {
    return (
      <div className="table-search">
        <div className="row">
          <div className="col-lg-2 col-sm-12">
            <div className="table-search-inner">
              <InputGroup className="mb-3">
                <Form.Control
                  value={filters.firstName}
                  onChange={(e) => onFilterChange(e, "firstName")}
                  placeholder="Search by First Name"
                />
                <InputGroup.Text id="basic-addon2">
                  <i className="fa fa-search"></i>
                </InputGroup.Text>
              </InputGroup>
            </div>
          </div>
          <div className="col-lg-2 col-sm-12">
            <div className="table-search-inner">
              <InputGroup className="mb-3">
                <Form.Control
                  value={filters.lastName}
                  onChange={(e) => onFilterChange(e, "lastName")}
                  placeholder="Search by Last Name"
                />
                <InputGroup.Text id="basic-addon2">
                  <i className="fa fa-search"></i>
                </InputGroup.Text>
              </InputGroup>
            </div>
          </div>
          <div className="col-lg-2 col-sm-12">
            <div className="table-search-inner">
              <InputGroup className="mb-3">
                <Form.Control
                  value={filters.email}
                  onChange={(e) => onFilterChange(e, "email")}
                  placeholder="Search by Email"
                />
                <InputGroup.Text id="basic-addon2">
                  <i className="fa fa-search"></i>
                </InputGroup.Text>
              </InputGroup>
            </div>
          </div>
          <div className="col-lg-2 col-sm-12">
            <div className="table-search-inner">
              <InputGroup className="mb-3">
                <Form.Control
                  value={filters.phone}
                  onChange={(e) => onFilterChange(e, "phone")}
                  placeholder="Search by Phone"
                />
                <InputGroup.Text id="basic-addon2">
                  <i className="fa fa-search"></i>
                </InputGroup.Text>
              </InputGroup>
            </div>
          </div>
          <div className="col-lg-2 col-sm-12">
            <div className="table-search-inner">
              <InputGroup className="mb-3">
                <Form.Control
                  value={filters.walletAddress}
                  onChange={(e) => onFilterChange(e, "walletAddress")}
                  placeholder="Search by Wallet Address"
                />
                <InputGroup.Text id="basic-addon2">
                  <i className="fa fa-search"></i>
                </InputGroup.Text>
              </InputGroup>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleClose = () => setShow(false);

  const handleShow = async (requestId) => {
    if (!requestId) {
      Swal.fire({
        title: "Error",
        text: "Request ID is missing.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_URL}/admin/allWalletRequestById/${requestId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSelectedRequest(response.data?.walletAddress);
      setReason(response.data?.walletAddress?.adminComment);
      setShow(true);
    } catch (error) {
      Swal.fire({
        title: messages.titles.error,
        text: messages.errors.fetchUsersFailed,
        icon: "error",
        confirmButtonText: messages.buttons.ok,
      });
    }
  };

  const handleApprove = () => {
    if (
      !selectedRequest ||
      !selectedRequest.userId ||
      !selectedRequest.walletAddress
    ) {
      Swal.fire({
        title: messages.titles.error,
        text: messages.errors.requiredFieldsFilled,
        icon: "error",
        confirmButtonText: messages.buttons.ok,
      });
      return;
    }

    const responseData = {
      walletAddress: selectedRequest.walletAddress,
      adminComment: reason,
      userId: selectedRequest.userId._id,
    };

    setLoading(true);

    axios
      .post(
        `${process.env.REACT_APP_API_ENDPOINT_URL}/admin/approveWalletAddress`,
        responseData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          Swal.fire({
            title: messages.titles.success,
            text: messages.success.successApproveRequest,
            icon: "success",
            confirmButtonText: messages.buttons.ok,
          });
          fetchAllPendingRequests();
        }
        setReason("");
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        let errorMessage = messages.errors.somethingWentWrong;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          errorMessage = error.response.data.message;
        }
        Swal.fire({
          title: messages.titles.error,
          text: errorMessage,
          icon: "error",
          confirmButtonText: messages.buttons.ok,
        });
      })
      .finally(() => {
        setLoading(false);
      });
    handleClose();
  };

  const handleReject = () => {
    if (
      !selectedRequest ||
      !selectedRequest.userId ||
      !selectedRequest.walletAddress
    ) {
      Swal.fire({
        title: messages.titles.error,
        text: messages.errors.requiredFieldsFilled,
        icon: "error",
        confirmButtonText: messages.buttons.ok,
      });
      return;
    }

    const responseData = {
      walletAddress: selectedRequest.walletAddress,
      adminComment: reason,
      userId: selectedRequest.userId._id,
    };

    setLoading(true);

    axios
      .post(
        `${process.env.REACT_APP_API_ENDPOINT_URL}/admin/rejectWalletAddress`,
        responseData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          Swal.fire({
            title: messages.titles.success,
            text: messages.success.successRejectRequest,
            icon: "success",
            confirmButtonText: messages.buttons.ok,
          });
          fetchAllPendingRequests();
        }
        setReason("");
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        let errorMessage = messages.errors.somethingWentWrong;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          errorMessage = error.response.data.message;
        }
        Swal.fire({
          title: messages.titles.error,
          text: errorMessage,
          icon: "error",
          confirmButtonText: messages.buttons.ok,
        });
      })
      .finally(() => {
        setLoading(false);
      });
    handleClose();
  };

  return (
    <>
      <NavBar />
      <div className={`sidebar-sec ${isOpen === true ? "active" : ""}`}>
        <section id="content-wrapper">
          <div className="row">
            <div className="col-lg-12 Application-content">
              <p className="content-title">Wallet Change Requests</p>
            </div>
          </div>
          <div className="table-box user-table">
            <DataTable
              value={sortedUsers}
              paginator
              rows={10}
              dataKey="_id"
              responsiveLayout="scroll"
              header={renderHeader()}
              onSort={onSort}
              sortField={sortField}
              sortOrder={sortOrder}
            >
              <Column
                field="serialNumber"
                header="S.No"
                body={(_, { rowIndex }) => {
                  const totalRecords = sortedUsers.length;
                  const globalIndex = rowIndex + 1;

                  if (sortField === "serialNumber" && sortOrder === -1) {
                    return totalRecords - rowIndex;
                  }
                  return globalIndex;
                }}
                sortable
              />
              <Column
                field="userId.firstName"
                header="First Name"
                body={(rowData) =>
                  capitalizeFirstLetter(rowData.userId?.firstName)
                }
                sortable
              />
              <Column
                field="userId.lastName"
                header="Last Name"
                body={(rowData) =>
                  capitalizeFirstLetter(rowData.userId?.lastName)
                }
                sortable
              />
              <Column
                field="userId.email"
                header="Email"
                body={(rowData) => rowData.userId?.email}
                sortable
              />
              <Column
                field="userId.phone"
                header="Phone"
                className="phone-nowrap"
                body={(rowData) => rowData.userId?.phone}
                sortable
              />
              <Column
                field="userId.walletAddress"
                header="Old Wallet Address"
                sortable
                body={(rowData) => (
                  <div className="copy-wallet">
                    <span>
                      {rowData.userId?.walletAddress
                        ? `${rowData.userId?.walletAddress.substring(
                            0,
                            4
                          )}...${rowData.userId?.walletAddress.slice(-4)}`
                        : ""}
                    </span>
                    {rowData.userId?.walletAddress ? (
                      <Tooltip title="Copy Wallet Address" arrow>
                        <FontAwesomeIcon
                          icon={faCopy}
                          className="copy-wallet-icon"
                          onClick={() =>
                            copyToClipboard(rowData.userId?.walletAddress)
                          }
                        />
                      </Tooltip>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              />
              <Column
                field="walletAddress"
                header="New Wallet Address"
                sortable
                body={(rowData) => (
                  <div className="copy-wallet">
                    <span>
                      {rowData.walletAddress
                        ? `${rowData.walletAddress.substring(
                            0,
                            4
                          )}...${rowData.walletAddress.slice(-4)}`
                        : ""}
                    </span>
                    {rowData.walletAddress ? (
                      <Tooltip title="Copy Wallet Address" arrow>
                        <FontAwesomeIcon
                          icon={faCopy}
                          className="copy-wallet-icon"
                          onClick={() => copyToClipboard(rowData.walletAddress)}
                        />
                      </Tooltip>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              />
              <Column
                field="status"
                header="Status"
                body={(rowData) => (
                  <div className="copy-wallet">
                    <span
                      className={
                        rowData.status === 1
                          ? "status-success"
                          : rowData.status === 2
                          ? "status-failed"
                          : "status-pending"
                      }
                    >
                      {rowData.status === 1
                        ? "Approved"
                        : rowData.status === 2
                        ? "Rejected"
                        : "Pending"}
                    </span>
                  </div>
                )}
                sortable
              />
              <Column
                header="Actions"
                body={(rowData) => (
                  <Button
                    variant="primary"
                    onClick={() => handleShow(rowData._id)}
                  >
                    View Details
                  </Button>
                )}
              />
            </DataTable>
          </div>
          <Modal size="lg" show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>Approve or Reject Request</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {selectedRequest && selectedRequest.userId ? (
                <div className="trans-content">
                  <p>User Details</p>
                  <div className="trans-content-inner">
                    <p>First Name:</p>
                    <span>{selectedRequest.userId.firstName}</span>
                  </div>
                  <div className="trans-content-inner">
                    <p>Last Name:</p>
                    <span>{selectedRequest.userId.lastName}</span>
                  </div>
                  <div className="trans-content-inner">
                    <p>Email: </p>
                    <span>{selectedRequest.userId.email}</span>
                  </div>
                  <div className="trans-content-inner">
                    <p>Phone: </p>
                    <span>{selectedRequest.userId.phone}</span>
                  </div>
                  <div className="copy-wallet">
                    <div className="trans-content-inner">
                      <p>Old Wallet Address:</p>
                      <span>
                        {selectedRequest?.userId?.walletAddress
                          ? `${selectedRequest.userId?.walletAddress.substring(
                              0,
                              4
                            )}...${selectedRequest.userId?.walletAddress.slice(
                              -4
                            )}`
                          : ""}
                      </span>
                      {selectedRequest?.userId?.walletAddress ? (
                        <Tooltip title="Copy Wallet Address" arrow>
                          <FontAwesomeIcon
                            icon={faCopy}
                            className="copy-wallet-icon"
                            onClick={() =>
                              copyToClipboard(
                                selectedRequest?.userId?.walletAddress
                              )
                            }
                          />
                        </Tooltip>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="copy-wallet">
                    <div className="trans-content-inner">
                      <p>New Wallet Address:</p>
                      <span>
                        {selectedRequest?.walletAddress
                          ? `${selectedRequest?.walletAddress.substring(
                              0,
                              4
                            )}...${selectedRequest?.walletAddress.slice(-4)}`
                          : ""}
                      </span>
                      {selectedRequest?.walletAddress ? (
                        <Tooltip title="Copy Wallet Address" arrow>
                          <FontAwesomeIcon
                            icon={faCopy}
                            className="copy-wallet-icon"
                            onClick={() =>
                              copyToClipboard(selectedRequest?.walletAddress)
                            }
                          />
                        </Tooltip>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="trans-content-inner">
                    <p>Request Reason: </p>
                    <span>{selectedRequest.reason}</span>
                  </div>
                  <div className="trans-content-inner">
                    <p>Status:</p>
                    <span>
                      {selectedRequest.status === 0
                        ? "Pending"
                        : selectedRequest.status === 1
                        ? "Approved"
                        : "Rejected"}
                    </span>
                  </div>
                  <div className="admin-comment">
                    <Form>
                      <Form.Group controlId="reasonTextArea">
                        <Form.Label>Comment(Optional)</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={reason}
                          onChange={(e) => setReason(e.target.value)}
                        />
                      </Form.Group>
                    </Form>
                  </div>
                </div>
              ) : (
                <p>Loading user details...</p>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Cancel
              </Button>
              {selectedRequest?.status === 0 && (
                <>
                  <Button variant="danger" onClick={handleReject}>
                    Reject
                  </Button>
                  <Button variant="success" onClick={handleApprove}>
                    Approve
                  </Button>
                </>
              )}
            </Modal.Footer>
          </Modal>
        </section>
      </div>
    </>
  );
};

export default AdminWalletChangeRequests;
